import { render, staticRenderFns } from "./FolhaRosto.vue?vue&type=template&id=93992612&scoped=true"
import script from "./FolhaRosto.vue?vue&type=script&lang=js"
export * from "./FolhaRosto.vue?vue&type=script&lang=js"
import style0 from "./FolhaRosto.vue?vue&type=style&index=0&id=93992612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93992612",
  null
  
)

export default component.exports